import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Image from "./image";

const FooterContainer = styled.footer`
    background-color: rgb(35, 35, 35);
    width: 100%;
    position: ${props => props.invert? 'static': 'static'};
    bottom: 0;
    z-index: 5;

    @media (max-width: 1200px) {
        position: static;
    }
`;

const FooterContent = styled.div`
    min-height: 130px;
    max-width: 900px;
    text-align: center;
    margin: 0 auto;
    padding: 16px 0;
    display: flex;
    align-items: center;
    flex-direction: ${props => props.invert? 'row': 'column'};

    @media (max-width: 1200px) {
        flex-direction: column;
        padding: 16px 10px;
    }
`;

const RiotLogo = styled.a`
    width: 150px;
    margin-right: ${props => props.invert? '91px': '0'};

    @media (max-width: 1200px) {
        width: 120px;
        margin-right: 0;
    }
`;

const Support = styled.div`
    font-family: 'Arial';
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    padding-top: 16px;
`

const SupportLink = styled.a`
    color: #fff;

    &:visited {
        color: #fff;
    }
`

const Disclaimer = styled.div`
    max-width: 678px;
    padding: 16px 0;
    color: #a4a4a4;
    font-family: 'Arial';
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    text-align: center;
`;

const Footer = ({ invert, id }) => (
    <FooterContainer id={id} invert={invert}>
        <FooterContent invert={invert}>
            <RiotLogo invert={invert} href="https://www.riotgames.com/ja" target="_blank" rel="noopener noreferrer">
                <Image name="riotGamesLogo"/>
            </RiotLogo>
            <div>
                <Support>
                    お問い合わせ：
                    <SupportLink href="https://support.riotgames.com/hc/ja" target="_blank" rel="noopener noreferrer">https://support.riotgames.com/hc/ja</SupportLink>
                </Support>
                <Support style={{paddingTop: 0}}>
                プライバシーノーティス：
                    <SupportLink href="https://www.riotgames.com/ja/privacy-notice-JP" target="_blank" rel="noopener noreferrer">https://www.riotgames.com/ja/privacy-notice-JP</SupportLink>
                </Support>
                <Disclaimer invert={invert}>
                    © 2020 Riot Games, Inc. All rights reserved. Riot Games, League of Legends and PvP.net are 
                    trademarks, services marks, or registered trademarks of Riot Games, Inc.
                </Disclaimer>
            </div>
        </FooterContent>
    </FooterContainer>
)

Footer.propTypes = {
    invert: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
}

export default Footer;
